export default "__VITE_ASSET__DhU0CcFm__"